export default __webpack_public_path__ + "static/media/05AW3AUG66.288d19cf.jpg";